import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findModuleName',
})
export class FindModuleNamePipe implements PipeTransform {
  constructor() {}

  transform(
    value: { name: string; newName: string }[],
    moduleName: string
  ): string {
    const module = value.find((item) => item.name === moduleName);
    return module?.newName || moduleName;
  }
}
